import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import moment from "moment";
const EsimDatePicker = ({ startDate, endDate, onApply, onCancel, minDate, t, }) => {
    const [selStart, setSelStart] = useState(startDate);
    const [selEnd, setSelEnd] = useState(endDate);
    const [selectingEnd, setSelectingEnd] = useState(false);
    const today = minDate || new Date();
    today.setHours(0, 0, 0, 0);
    const baseMonth = moment(startDate).startOf("month");
    const month1 = baseMonth.clone();
    const month2 = baseMonth.clone().add(1, "month");
    const handleDayClick = (day) => {
        if (day < today)
            return;
        if (!selectingEnd) {
            setSelStart(day);
            setSelEnd(null);
            setSelectingEnd(true);
        }
        else {
            if (day <= selStart) {
                setSelStart(day);
                setSelEnd(null);
            }
            else {
                setSelEnd(day);
                setSelectingEnd(false);
            }
        }
    };
    const handleApply = () => {
        if (selStart && selEnd && selStart < selEnd) {
            onApply(selStart, selEnd);
        }
    };
    const isValid = selStart && selEnd && selStart < selEnd;
    const renderMonth = (monthMoment) => {
        const startOfMonth = monthMoment.clone().startOf("month");
        const endOfMonth = monthMoment.clone().endOf("month");
        const startDay = startOfMonth.day();
        const daysInMonth = monthMoment.daysInMonth();
        const cells = [];
        for (let i = 0; i < startDay; i++) {
            cells.push(_jsx("span", { className: "esim-calendar__day esim-calendar__day--empty" }, `empty-${i}`));
        }
        for (let d = 1; d <= daysInMonth; d++) {
            const date = monthMoment.clone().date(d).toDate();
            date.setHours(0, 0, 0, 0);
            const isPast = date < today;
            const isStart = selStart && date.getTime() === selStart.getTime();
            const isEnd = selEnd && date.getTime() === selEnd.getTime();
            const isInRange = selStart && selEnd && date > selStart && date < selEnd;
            const classes = [
                "esim-calendar__day",
                isPast && "esim-calendar__day--disabled",
                isStart && "esim-calendar__day--start",
                isEnd && "esim-calendar__day--end",
                isInRange && "esim-calendar__day--range",
            ]
                .filter(Boolean)
                .join(" ");
            cells.push(_jsx("span", { className: classes, onClick: () => !isPast && handleDayClick(date), children: d }, d));
        }
        const weekDays = [
            t("esim_weekday_mon"),
            t("esim_weekday_tue"),
            t("esim_weekday_wed"),
            t("esim_weekday_thu"),
            t("esim_weekday_fri"),
            t("esim_weekday_sat"),
            t("esim_weekday_sun"),
        ];
        return (_jsxs("div", { className: "esim-calendar__month", children: [_jsx("div", { className: "esim-calendar__month-title", children: monthMoment.format("MMMM YYYY") }), _jsx("div", { className: "esim-calendar__weekdays", children: weekDays.map((wd) => (_jsx("span", { className: "esim-calendar__weekday", children: wd }, wd))) }), _jsx("div", { className: "esim-calendar__grid", children: cells })] }));
    };
    return (_jsxs("div", { className: "esim-calendar", children: [_jsxs("div", { className: "esim-calendar__months", children: [renderMonth(month1), renderMonth(month2)] }), _jsxs("div", { className: "esim-calendar__actions", children: [_jsx("button", { className: "esim-calendar__btn esim-calendar__btn--cancel", onClick: onCancel, type: "button", children: t("esim_cancel_dates") }), _jsx("button", { className: "esim-calendar__btn esim-calendar__btn--apply", onClick: handleApply, disabled: !isValid, type: "button", children: t("esim_apply_dates") })] })] }));
};
export default EsimDatePicker;
